module.exports = __webpack_public_path__ + "img/floor1.5d66fba7.jpg";